import React from 'react';
import { Home } from 'Home';
import { Navigate, useLocation, useOutlet } from 'react-router';
import { useLocalStorageState, useMount } from 'ahooks';
import GlobalErrorBoundary from 'Common/Components/GlobalErrorBoundary';
import { AccountPersistInfo } from 'Internal.CommonAPI';
import { useCommonInfo } from 'Common/hooks/info';
import Widgets from 'Widgets';

const GlobalRoute = () => {
  const outlet = useOutlet();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  if (!account?.email) {
    return <Navigate to="/login" />;
  }

  if (!account?.userToken) {
    return <Navigate to="/pin" />;
  }
  return outlet;
};

const InstantLoginRoute = () => {
  const outlet = useOutlet();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  if (!account?.userToken) {
    return <Navigate to="/login" />;
  }
  if (account?.userToken) {
    return <Navigate to="/" />;
  }
  return outlet;
};

const PublicRoute = () => {
  const outlet = useOutlet();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');

  if (account?.email && account?.userToken) {
    return <Navigate to="/" />;
  }
  return outlet;
};

const PinRoute = () => {
  const outlet = useOutlet();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');

  if (!account?.email && !account?.userToken) {
    return <Navigate to="/login" />;
  }

  if (account?.userSuccessful !== undefined && !account?.userSuccessful) {
    return <Navigate to="/pin" />;
  }
  return outlet;
};

const PrivateRoute = () => {
  const outlet = useOutlet();
  const [account] = useLocalStorageState<AccountPersistInfo>('account');
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const commonApiInfoQuery = useCommonInfo();

  useMount(() => {
    if (commonApiInfoQuery.data === undefined && account) {
      commonApiInfoQuery.refetch();
    }
  });

  if (
    !account ||
    (token === undefined &&
      (account?.userToken === undefined ||
        account?.userSuccessful === undefined)) ||
    account?.userToken === undefined ||
    !account.userToken
  ) {
    localStorage.removeItem('account');
    localStorage.removeItem('ledger-length');
    localStorage.removeItem('pre-accounting');
    return <Navigate to="/login" />;
  }
  if (
    token === undefined &&
    (account?.userToken === undefined || !account.userToken) &&
    !account?.email
  ) {
    return <Navigate to="/login" />;
  }
  if (
    token === undefined &&
    account?.userToken !== undefined &&
    !account.userToken
  ) {
    return <Navigate to="/pin" />;
  }

  if (account?.userSuccessful !== undefined && account?.userSuccessful) {
    return (
      <>
        <Home>{outlet}</Home>
        <GlobalErrorBoundary>
          <Widgets />
        </GlobalErrorBoundary>
      </>
    );
  }

  return null;
};

export { GlobalRoute, PublicRoute, PrivateRoute, PinRoute, InstantLoginRoute };
